<p-dialog
  [visible]="state().visible"
  (visibleChange)="onVisibleChange($event)"
  [modal]="true"
  [closable]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: 'min(92vw, 30rem)' }"
  styleClass="unsafe-repricing-confirm-modal"
  [header]="'REPRICING.UNSAFE_CONFIRM.TITLE' | translate"
>
  @if (state().details; as details) {
    <div class="warning-body">
      <p class="warning-text">
        @if (isList()) {
          {{
            'REPRICING.UNSAFE_CONFIRM.MESSAGE_LIST'
              | translate: { count: state().detailsList.length }
          }}
        } @else {
          {{
            'REPRICING.UNSAFE_CONFIRM.MESSAGE'
              | translate
                : {
                    currentPrice: priceText().currentPrice,
                    proposedPrice: priceText().proposedPrice
                  }
          }}
        }
      </p>

      <div class="unsafe-list" aria-live="polite">
        @for (row of priceRows(); track row.details.product_id) {
          <div
            class="unsafe-item"
            [class.is-selected]="isSelected(row.details.product_id)"
          >
            <label class="selection-row">
              <input
                type="checkbox"
                class="selection-checkbox"
                [checked]="isSelected(row.details.product_id)"
                [attr.aria-label]="
                  'REPRICING.UNSAFE_CONFIRM.SELECT_ITEM'
                    | translate: { productId: row.details.product_id }
                "
                (change)="toggleSelection(row.details.product_id, $event)"
              />

              <span class="price-change">
                <span>{{ row.currentPrice }}</span>
                <span aria-hidden="true">→</span>
                <span>{{ row.proposedPrice }}</span>
              </span>
            </label>

            <div class="meta">
              <span>{{ row.details.marketplace }}</span>
              <span>{{ row.details.product_id }}</span>
              <span>
                {{
                  'REPRICING.UNSAFE_CONFIRM.REASON.' + row.details.reason
                    | translate
                }}
              </span>
              @if (row.details.commission_source) {
                <span>
                  {{
                    'REPRICING.UNSAFE_CONFIRM.COMMISSION_SOURCE'
                      | translate: { source: row.details.commission_source }
                  }}
                </span>
              }
            </div>
          </div>
        }
      </div>
    </div>
  }

  <ng-template pTemplate="footer">
    <button
      pButton
      type="button"
      class="p-button-text"
      [label]="'REPRICING.UNSAFE_CONFIRM.CANCEL' | translate"
      (click)="cancel()"
      data-testid="unsafe-repricing-cancel"
    ></button>
    <button
      pButton
      type="button"
      severity="warning"
      [label]="
        (isList()
          ? 'REPRICING.UNSAFE_CONFIRM.CONFIRM_SELECTED'
          : 'REPRICING.UNSAFE_CONFIRM.CONFIRM'
        ) | translate: { count: selectedCount() }
      "
      [disabled]="selectedCount() === 0"
      (click)="confirm()"
      data-testid="unsafe-repricing-confirm"
    ></button>
  </ng-template>
</p-dialog>
